import { render } from "./StatisticsNotAvailable.vue?vue&type=template&id=151e7565"
import script from "./StatisticsNotAvailable.vue?vue&type=script&lang=js"
export * from "./StatisticsNotAvailable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__